export default __webpack_public_path__ + "static/media/broadcast.40907abc.png";